import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import { IonContent, IonPage, useIonToast, useIonViewWillEnter, IonLoading, useIonRouter, IonIcon } from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { barcodeOutline, informationCircle } from 'ionicons/icons';
import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import ScanAsset from '../../assets/ScanAsset.svg';
import axios from '../../axios';
import Header from '../../components/Header';
import { createAssetomponent } from '../../models/createAssetComponent';
import { AppContext } from '../../providers/AppContext';
import {
  createFormJsonData,
  getSetComponentCategory,
  getSetComponentType,
  offlineSaveToTable,
  requestPermissions,
  resetForm,
} from '../../utils';



const CreateComp: React.FC = () => {

  const [isScan, setIsScan] = useState(false);

  const [showLoading, setShowLoading] = useState(false);
  const [isOnline, setIsOnline] = useState(Boolean);

  const [data, setData] = useState<any>(createAssetomponent);

  const { dispatch } = useContext(AppContext);

  const handleChange = (event: any) => {
    const formentry: any = [...data];
    const f_index = formentry.findIndex((v: any) => v.field === event.target.id);
    const change_form_object = formentry[f_index];
    change_form_object.value = event.target.value;
    formentry[f_index] = change_form_object;
    setData(formentry);
  };

  const handleSelectChange = (event: any) => {
    const formentry: any = [...data];

    const select = event.target.name.replaceAll('-', '_');
    const f_index = formentry.findIndex((v: any) => v.field === select);
    formentry[f_index].value = event.target.value;
    setData(formentry);
  };

  const router = useIonRouter();
  const [present] = useIonToast();

  const { t } = useTranslation();

  const url = '/resource/Asset Components';

  useIonViewWillEnter(async () => {
    // get component category
    const Data = [...data];
    const ccat = Data.findIndex((d) => d.field === 'component_category');

    Data[ccat].options = await getSetComponentCategory();

    // get component type
    const ctype = Data.findIndex((d) => d.field === 'component_type');
    Data[ctype].options = await getSetComponentType();

    setData(Data);
  });

  useEffect(() => {
    (async () => {
      const internetStatus = await Network.getStatus();
      setIsOnline(internetStatus.connected);

      Network.addListener('networkStatusChange', (status) => {
        setIsOnline(status.connected);
      });
    })();
  }, []);

  // Mapping fields after scan
  //  const callComponentById = () => {
  //   axios({
  //     method: 'get',
  //     url: '/resource/Asset Components/PROJ-0001-TASK-2021-00004-00010_Poste betão_00125',
  //     headers: {
  //       Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
  //     },
  //   })
  //     .then((res) => {
  //       const temp = res.data.data
  //       for(const x in createAssetomponent){
  //         const f = createAssetomponent[x].field
  //         if(f === 'component_name'){
  //           createAssetomponent[x].value = temp['component_category']
  //         } else if(f){
  //           createAssetomponent[x].value = temp[f]
  //         }
  //       }
  //       setData(createAssetomponent)
  //     })
  //     .catch((err) => {
  //     });
  // }

  const Submit = (e: any) => {
    e.preventDefault();
    let valid = true;
    for (const x in data) {
      if (data[x].required && !data[x].value) {
        present({
          message: data[x].requiredText,
          color: 'danger',
          duration: 2000,
        });
        valid = false;
      }
    }
    if (valid) {
      const api_data: any = createFormJsonData(data);

      api_data.external_component = parseInt(api_data.external_component);
      const config: any = {
        method: 'post',
        url,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
        },
        data: api_data,
      };

      setShowLoading(true);

      if (isOnline) {
        axios(config)
          .then((res) => {
            if (res.status === 200) {
              present({
                message: t('CreateAC.createAc'),
                duration: 2000,
              });
              setData(resetForm(data));
              router.goBack();
            }
          })
          .catch(function (error) {
            console.log(error?.response?.data);
            const x = error?.response?.data?._server_messages;
            console.log(x?.slice(18)?.slice(0, x?.slice(18)?.indexOf('\\')));
            present({
              message: x?.slice(18)?.slice(0, x?.slice(18)?.indexOf('\\')),
              color: 'danger',
              duration: 2000,
            });
          })
          .finally(() => {
            setShowLoading(false);
          });
      } else {
        // save data in storage
        offlineSaveToTable(api_data, url, 'Component');
        dispatch({ type: 'toggleOfflineSave', payload: {} });
        setData(resetForm(data));
        router.goBack();
      }
    }
  };

  const getScan = async () => {
    const info = await Device.getInfo();
    if (info?.platform === 'web') {
      present({
        message: t('Utils.scannerNotSupported'),
        duration: 2000,
      });
      return
    }
    try {
      BarcodeScanner.isSupported().then((result) => {
        if (!result.supported) {
          present({
            message: t('Utils.unsupportDevice'),
            duration: 2000,
          });
        }
      });

      const granted = await requestPermissions();
      if (!granted) {
        present({
          message: t('Utils.noPermission'),
          duration: 2000,
        });
        return;
      }
      const check = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable()
      if (!check.available)
        BarcodeScanner.installGoogleBarcodeScannerModule()
      const { barcodes } = await BarcodeScanner.scan();
      const scannedValue = barcodes[0]?.displayValue
      handleScan(scannedValue);
    } catch (error: any) {
      console.log(error)
    }
  };

  const handleScan = (code: any) => {
    if (code) {
      try {
        const formentry: any = [...data];
        const f_index = formentry.findIndex((v: any) => v.field === 'barcode_id');
        const change_form_object = formentry[f_index];
        change_form_object.value = code;
        formentry[f_index] = change_form_object;
        setData(formentry);
      } catch (error: any) {
        console.log(error);
      }

    }
  }



  return (
    <IonPage>
      <Header enableBackButton='goBack' title={t('Assets.CreateA.assetC')} />
      <IonContent>
        <IonLoading

          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={t('Utils.pleasewait')}
          duration={5000}
        />

        <div style={{ display: 'flex', margin: 'auto', paddingTop: '2rem' }}>
          <button
            onClick={() => setIsScan(true)}
            style={{
              margin: 'auto',
              background: 'transparent',
              boxShadow: '1.75499px 7.01994px 42.1197px -14.0399px rgba(0, 0, 0, 0.1)',
              borderRadius: '1rem',
            }}
          >
            <img src={ScanAsset} alt="scan" style={{ paddingTop: '1rem' }} />
            <p style={{ margin: 'auto', color: 'rgba(29, 80, 141, 1)', marginTop: '2px', fontSize: '11px' }}>
              {t('Assets.Scan')}
            </p>
          </button>
        </div>

        <p
          style={{
            margin: 'auto',
            color: 'rgba(36, 54, 86, 1)',
            marginTop: '2rem',
            fontSize: '11px',
            opacity: '0.5',
            textAlign: 'center',
          }}
        >
          {t('Assets.CreateA.Fill')}.
        </p>

        <form className="ion-margin-top" style={{ textAlign: 'center' }} onSubmit={(e) => Submit(e)}>
          {data.map((form_field: any, index: any) => {
            if (form_field.title) {
              return (
                <p className="form-title" key={`${form_field.title}-${index}`}>
                  {t(form_field.title)}
                </p>
              );
            } else if (form_field.type === 'text') {
              return (
                <div className="input-container" key={`${form_field.field}-${index}`}>
                  <label className="label">
                    {t(form_field.label)}
                    {form_field.required ? '*' : null}
                  </label>
                  <input
                    required={form_field.required}
                    className="basic-input"
                    id={form_field.field}
                    placeholder={t(form_field.label)}
                    onChange={handleChange}
                    value={form_field.value}
                  />
                </div>
              );
            } else if (form_field.type === 'textarea') {
              return (
                <div className="input-container" key={`${form_field.field}-${index}`}>
                  <label className="label">
                    {t(form_field.label)}
                    {form_field.required ? '*' : null}
                  </label>
                  <textarea
                    className="textarea"
                    required={form_field.required}
                    id={form_field.field}
                    placeholder={t(form_field.label)}
                    onChange={handleChange}
                    value={form_field.value}
                  />
                </div>
              );
            } else if (form_field.type === 'select') {
              return (
                <div className="input-container" key={`${form_field.field}-${index}`}>
                  <label className="label">
                    {t(form_field.label)}
                    {form_field.required ? '*' : null}{' '}
                  </label>
                  {form_field.info ? (
                    <div className="tooltip">
                      <IonIcon style={{ marginBottom: '-4px' }} src={informationCircle} />
                      <span className="tooltiptext">{t(`Utils.${form_field.info}`)}</span>
                    </div>
                  ) : null}
                  <Select
                    className="custom-select"
                    required={form_field.required}
                    id={`${form_field.field}_choice`}
                    name={form_field.field}
                    onChange={handleSelectChange}
                    value={form_field.value}
                  >
                    {form_field.options?.map(function (opt: any, indexSelect: any) {
                      return (
                        <MenuItem
                          value={`${opt}`}
                          key={`${form_field.field}-${indexSelect}`}
                          id={`${opt}_item_${indexSelect}`}
                        >
                          <section style={{ display: 'flex', height: '1rem' }}>
                            <p
                              style={{
                                color: 'rgba(31, 87, 148, 1)',
                                marginLeft: '0.2rem',
                                fontSize: '12px',
                                marginTop: '0px',
                              }}
                            >
                              {t(opt)}
                            </p>
                          </section>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </div>
              );
            } else if (form_field.type === 'date') {
              return (
                <div className="input-container" key={`${form_field.field}-${index}`}>
                  <label className="label">
                    {t(form_field.label)}
                    {form_field.required ? '*' : null}
                  </label>
                  <input
                    required={form_field.required}
                    className="date"
                    id={form_field.field}
                    placeholder={t(form_field.label)}
                    onChange={handleChange}
                    value={form_field.value}
                    type="date"
                  />
                </div>
              );
            }
            else if (form_field.type === 'barcode') {
              return (
                <div
                  id={`${form_field.field}-${index}`}
                  className="input-container"
                  key={`${form_field.field}-${index}`}
                >
                  <label id={`label-${form_field.field}`} style={{ marginTop: '1rem' }} className="label">
                    {t(`Assets.CreateA.${form_field.field}`)}
                    {form_field.required ? '*' : null}{' '}
                  </label>
                  <div className="flex items-center justify-between basic-input">
                    <input
                      required={form_field.required}
                      className="gps-input"
                      id={form_field.field}
                      placeholder={t(`Assets.CreateA.${form_field.field}`)}
                      value={form_field.value}
                      disabled={true}
                      style={{ width: '80%' }}
                    />
                    <IonIcon onClick={() => getScan()} className="gps-icon" src={barcodeOutline} />
                  </div>
                </div>
              );
            }

            else {
              return '';
            }
          })}
          <button className="submit-button" type="submit">
            {t('CreateAC.CAC')}
          </button>
        </form>
        <div style={{ marginBottom: '1rem' }}></div>
      </IonContent>
    </IonPage>
  );
};

export default CreateComp;
